import logo from './logo.svg';
import './App.css';
import iguana from './iguana.jpg';
import VocabCard from './Components/VocabCard.js';
import MenuCard from './Components/MenuCard.js';
import SmartInput from './Components/SmartInput.js';
import TopAppBar from './Components/TopAppBar.js';
import FolderList from './Components/FolderList.js';
import WordListDialog from './Components/WordListDialog.js';
import WordTable from './Components/WordTable.js';
import WordsPage from './WordsPage.js';
import FillInTheBlanksPage from './FillInTheBlanksPage.js';
import CurriculumPage from './CurriculumPage.js';
import AboutPage from './AboutPage.js';
import SvgMagic from './Components/SvgMagic.js'
import Skeleton from '@mui/material/Skeleton';
import NotFound from './NotFound.js';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import Map from './Components/Map.js'

import LoginPage from './Components/GPTLogin.js'

import CircularProgress from '@mui/material/CircularProgress';

import { BrowserRouter as Router, Switch, Route, Routes, Link, Outlet} from "react-router-dom";
import { Navigate } from 'react-router-dom';

import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import CardMedia from '@mui/material/CardMedia';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import RapidFirePage from './RapidFirePage.js'

import Fab from '@mui/material/Fab';
import SaveIcon from '@mui/icons-material/Save';

import { makeStyles } from '@mui/material/styles';
import WallAppBar from './Components/AppBar/WallAppBar.js'
import Cookies from 'js-cookie';
import Morse from "./Morse.js";
import IosMorse from "./IosMorse.js";
import Config from "./Config.json";
import ReactGA from "react-ga4";

import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

import axios from 'axios';
/*
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFilledInput-root": {
      background: "rgb(232, 241, 250)"
    }
  }
}));
*/

ReactGA.initialize(Config.GAID)

const theme = createTheme({
  palette: {
    primary: {
      main: '#008000',
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: '#9c5a3c',
      light: '#F5EBFF',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#47008F',
    },
  },
});


var words = ["toucher", "passeport", "apres-midi", "minuit", "avant", "stylo", "crayon", "voiture"];
var wordCardBank = [["cafe", "the", "poisson"], ["passeport", "apres-midi", "minuit"], ["stylo", "crayon", "voiture"]];
var ansBank = ["cafe", "passeport", "crayon"]
var englishWord = ["Coffee", "Passport", "Pencil"]

var lessonData = [
    {
      "wordCards": ["cafe", "the", "poisson"],
      "answer": "cafe",
      "englishWord":"",
      "definitions":["coffee", "tea", "fish"],
      "icons":[
        "iVBORw0KGgoAAAANSUhEUgAAABcAAAABCAIAAAC6x6JxAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAWSURBVBhXYwCC",
        "iVBORw0KGgoAAAANSUhEUgAAABcAAAABCAIAAAC6x6JxAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAWSURBVBhXYwCC",
        "iVBORw0KGgoAAAANSUhEUgAAABcAAAABCAIAAAC6x6JxAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAWSURBVBhXYwCC"
      ]
    }
];

function App() {

  const [dataLoaded, setDataLoaded] = useState(false);
  const [chosen, setChosen] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [correct, setCorrect] = useState(false);
  const [open, setOpen] = useState(false);
  const [wordIndex, setWordIndex] = useState(0);
  const [showCards, setShowCards] = useState(true);

  const [loadingOpen, setLoadingOpen] = useState(false);

  const [lessonDataState, setLessonDataState] = useState(lessonData);

  const [submitAnswerSuccess, setSubmitAnswerSuccess] = useState(false);
  const [cardsPerQuiz, setCardsPerQuiz] = useState(3);
  // var for seeing if wallappbar dialog is open. if open, disable onKeyDown actions
  const [isDialogClosed, setIsDialogClosed] = useState(true);

  //breadcrumbs for top app bar. VocabApp -> Picture Cards
  const breadcrumbs = [
    <Link underline="hover" to="/" key="1" color="white" href="/">
      Vocab App
    </Link>,
    <Typography key="3" color="white">
      Learn
    </Typography>,
  ];

  var wi = wordIndex;
  var wordCards = lessonDataState[wordIndex]["wordCards"]//  wordCardBank[wordIndex];
  var ans = lessonDataState[wordIndex]["answer"] //ansBank[wordIndex];

  var answerHistory = [];

  useEffect(() => {
    if (chosen !== "") {
      answer();
    }
  }, [chosen]);

  useEffect(() => {
    axios.get(Config.urlStub + "/pictureCardData", {params:{"sampleSize":cardsPerQuiz}, withCredentials:true}
    ).then((response) => {
        lessonData = response.data;
        setLessonDataState(response.data);
        setDataLoaded(true);
      }).catch(function (error) {
        console.log(error);
      })

    setShowCards(false);
    // console.log("showcards is false");
    setTimeout(() => {
      setShowCards(true);
    }, 100)
    // console.log("showcards is true");

    function ael() {
      window.addEventListener('keydown', onKeyPressed, false);
      return () => window.removeEventListener('keydown', onKeyPressed, false);
    }

    if (Cookies.get("session_id") != null) {
      axios.get(Config.urlStub + "/getUserPref", {withCredentials:true}).then((response) => {
        if (response.data.cardsPerQuiz !== undefined) {
          setCardsPerQuiz(response.data.cardsPerQuiz);
        }
      }).catch(function (error) {
          console.log(error);
      })
    }

    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Main" });

  }, []);

  // function flipCard(i) {
  //   lessonDataState[wordIndex]["definitions"];
  // }

  function nextQuestion() {

    console.log('nextQuestion clicked')

    var destLang = Cookies.get("user_destLang");
    if (destLang === undefined || destLang == null) {
      // return;
    } else {
      var dataToSubmit = {
        "lang":Config.countryLangMapping[destLang],
        "word":lessonDataState[wordIndex]["answer"],
        "familiarity":true
      };
      console.log("sending updateFam with destLang", Config.countryLangMapping[destLang], destLang);
      axios.post(Config.urlStub + "/updateFamiliarity", dataToSubmit, {withCredentials: true}).then((response) => {
        //lessonData = response.data;
      //   setWords(response.data)
      }).catch((error) => {
        console.log(error);
      });
    }

    
    // console.log("lessonDataState.length is", lessonDataState.length, "and wordIndex is", wordIndex)
    /*
    if (wordIndex >= lessonDataState.length - 2) {
      //TODO: skip to loading page, post answerHistory to backend
      console.log("end reached");

      wordCards = lessonDataState[wordIndex+1]["wordCards"];
      setWordIndex(wordIndex + 1);
      setLoadingOpen(true);
      setChosen("");
      setSubmitted(false);
      setCorrect(false);
      axios.post(Config.urlStub + "pictureCardSubmitAnswers", answerHistory).then((response) => {
        //TODO: enable buttons for going to home or continuing lesson
        setSubmitAnswerSuccess(true);
        setLoadingOpen(false);
      });
      return;
    }
    */

    setShowCards(false);
    setTimeout(() => {
      setShowCards(true);
    }, 300)
    if (wordIndex >= lessonDataState.length - 2) {

      // axios.post("/pictureCardSubmitAnswers", answerHistory).then((response) => {
      //   // console.log("Answers submitted; response is", response.data);
      // });

      // body: {"familiarity": 1 (negative if wrong answer), "word": "cow", "lang":en }
      var destLang = Cookies.get("user_destLang");
      if (destLang === undefined || destLang == null) {
        destLang = Cookies.get("anon_destLang");
        if (destLang === undefined || destLang == null) {
          destLang = "fr";
        }
        // return;
      }
      axios.get(Config.urlStub + "/pictureCardData", {withCredentials:true}).then(async (response) => {
        var newData = response.data;
        var newLessonState = [];
        for (var i = wordIndex; i < lessonDataState.length; i++) {
          newLessonState.push(lessonDataState[i]);
        }
        newLessonState = newLessonState.concat(newData);
        setLessonDataState(newLessonState);

        setWordIndex(1);
        setChosen("");
        setSubmitted(false);
        setCorrect(false);
      });
      // experiment
      setChosen("");
      setWordIndex(wordIndex + 1);
      setSubmitted(false);
      setCorrect(false);
      return;
    }

    // setTimeout(() => {
      // console.log("setting stuff")
      setChosen("");
      setWordIndex(wordIndex + 1);
      setSubmitted(false);
      setCorrect(false);
    // }, 100)
  }

  function updateChosenWord(word) {
    // console.log("new chosen is", word);
    setChosen(word);
    // console.log("new chosen is", open);
  }

  function getDestLangFromCookies() {
    if (Cookies.get("user_destLang") !== undefined) {
      return Cookies.get("user_destLang");
    } else {
      return Cookies.get("anon_destLang");
    }
  }

  function answer() {
    setSubmitted(true);
    if (chosen == ans) {
      // answer was right, move to next one.
      // answerHistory.push({"isCorrect": true, "answerGiven":ans});
      setCorrect(true);
      // console.log(String(correct));
    } else {
      // answerHistory.push({"isCorrect": false, "answerGiven":ans, "rightAnswer":chosen});
      // answer was wrong, do wiggle or something
      setOpen(true);
    }
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  function onKeyPressed(key) {
    if (!isDialogClosed) {
      return;
    }
    wi = wordIndex;
    //console.log(key.code)
    if (key.code == "Enter" || key.code == 'NumpadEnter') {
      // console.log("enter is pressed")
      if ((chosen !== "" && !correct)) {
        answer();
      } else if (correct) {
        // console.log("advancing to next question")
        nextQuestion();
      }
      //advance to next one, whether it be submit or newset.
    }
    if (correct) {
      return;
    }
    else if (key.code == "Digit1") {
      // console.log(1);
      updateChosenWord(lessonDataState[wi]["wordCards"][0]);
    } else if (key.code == "Digit2") {
      // console.log(1);
      updateChosenWord(lessonDataState[wi]["wordCards"][1]);
    } else if (key.code == "Digit3") {
      // console.log(1);
      updateChosenWord(lessonDataState[wi]["wordCards"][2]);
    }
    return;
  }

  return (
    <div className="App-header" onKeyDown={onKeyPressed} tabIndex="0" sx={{mb:2}}>
      {/* <TopAppBar breadcrumbs={breadcrumbs} /> */}
         <WallAppBar setStartCounting={setIsDialogClosed} />
          <Typography sx={{ fontSize: 40, color: "#FFFFFF", mt:'70px' }} color="text.primary" gutterBottom align="center">
            {lessonDataState[wordIndex]["englishWord"]}
          </Typography>

      <Grid container maxWidth="100%" sx={{alignItems:"center", justifyContent:"center", direction:"row", mb:'60px'}}>

            {
              !dataLoaded &&
              [0,1,2].map(function(object, i) {
                return (
                    <Skeleton variant="rectangular" width={250} height={250} sx={{margin:1}} />
                )
              })
            }
            {dataLoaded && lessonDataState[wordIndex]["wordCards"].map(function(object, i){
                return (
                  <Grid item>
                    <VocabCard showCards={showCards} ans={ans} done={correct} variant={object == chosen ? "contained" : "text"}
                     onClick={updateChosenWord} imgbase64={`data:image/jpg;base64,` + lessonDataState[wordIndex]["icons"][i]} 
                     alt="image" name={object} def={lessonDataState[wordIndex]["definitions"][i]}
                     
                     audioUrl={Config.urlStub + "" + Config.countryLangMapping[getDestLangFromCookies()]
                      + "/" + lessonDataState[wordIndex]["wordCards"][i] + ".wav"} />
                  </Grid>
                )
            })}

      </Grid>

      {/* { !loadingOpen &&
        <Button onClick={() => answer()} disabled={chosen === "" || correct}>
          <KeyboardArrowRightIcon sx={{ fontSize: 70 }}/>
        </Button>
      }

      {loadingOpen && <CircularProgress size={100} open={false}/>} */}

      {/*
      submitAnswerSuccess && 
        <Button onClick={() => answer()} >
          <Typography sx={{ fontSize: 22, color: "#FFFFFF" }} color="text.primary" gutterBottom align="center">
            HOME
          </Typography>
        </Button>
        */
      }
      
      {correct &&
        <Snackbar open={true} onClick={() => nextQuestion()} onClose={handleClose} anchorOrigin={{horizontal: 'center', vertical: 'bottom'}}>
          <Alert severity="success" action={
                                            <Button color="inherit" size="small" onKeyDown={(e) => {
                                              console.log(e.key);
                                            }} >
                                              CONTINUE [ENTER]
                                            </Button>
                                          }>
            Correct!
          </Alert> 
        </Snackbar>
      }

    
      {(!correct && submitted) ? 
        <Snackbar open={open} autoHideDuration={1000} onClose={handleClose} anchorOrigin={{horizontal: 'center', vertical: 'bottom'}}>
          <Alert severity="error">
            Wrong!
          </Alert> 
        </Snackbar>
      : <div/> }

    </div>
  );
}

function Home() {
  return (
    <div>
      <h2>Home</h2>
    </div>
  );
}


function Layout() {
  return (
    <div>
      {/* A "layout route" is a good place to put markup you want to
          share across all the pages on your site, like navigation. */}
      {/* <nav>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/words">Words</Link>
          </li>
          <li>
            <Link to="/app">App</Link>
          </li>
          <li>
            <Link to="/fitb">FITB</Link>
          </li>
          <li>
            <Link to="/curriculum">Curriculum</Link>
          </li>
          <li>
            <Link to="/rapidfire">Curriculum</Link>
          </li>
          
        </ul>
      </nav> */}

      {/* <hr /> */}

      {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
      <Outlet />
    </div>
  );
}



function MyRouter() {
  return (

      <div>
      {/* <h1>Basic Example</h1>

      <p>
        This example demonstrates some of the core features of React Router
        including nested <code>&lt;Route&gt;</code>s,{" "}
        <code>&lt;Outlet&gt;</code>s, <code>&lt;Link&gt;</code>s, and using a
        "*" route (aka "splat route") to render a "not found" page when someone
        visits an unrecognized URL.
      </p> */}

      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<App />} />
          <Route path="words" element={<ThemeProvider theme={theme}><WordsPage /></ThemeProvider>} />
          <Route path="app" element={<ThemeProvider theme={theme}><App /></ThemeProvider>} />
          <Route path="fitb" element={<ThemeProvider theme={theme}><FillInTheBlanksPage /></ThemeProvider>} />
          <Route path="curriculum" element={<CurriculumPage />} />
          <Route path="about" element={<ThemeProvider theme={theme}><AboutPage /></ThemeProvider>} /> 
          <Route path="rapidfire" element={<ThemeProvider theme={theme}><RapidFirePage /></ThemeProvider>} />
          <Route path="map" element={<Map />} />
          {/* <Route path="morse" element={<Morse />} /> */}
          <Route path="iosmorse" element={<IosMorse />} />
          {/* <Route path="svgmagic" element={<SvgMagic />} /> */}
          <Route path="404" element={<NotFound />} />
          <Route path="*" element={<Navigate replace to="/404" />} />
        </Route>
      </Routes>

      </div>
  )
}


export default MyRouter ; //LoginPage;//